import { useEffect, useState } from "react";

const readViewport = () => {
  if (typeof window === "undefined") return { height: 0, top: 0 };
  const viewport = window.visualViewport;
  return {
    height: Number.isFinite(viewport?.height) && viewport.height > 0 ? viewport.height : window.innerHeight,
    top: Number.isFinite(viewport?.offsetTop) && viewport.offsetTop > 0 ? viewport.offsetTop : 0,
  };
};

// Mobile browser chrome and keyboards can shrink/pan the visible viewport
// without resizing the layout viewport used by fixed heights and 100vh.
export default function useVisibleViewport() {
  const [viewport, setViewport] = useState(readViewport);
  useEffect(() => {
    const visible = window.visualViewport;
    const update = () => setViewport(readViewport());
    window.addEventListener("resize", update);
    visible?.addEventListener("resize", update);
    visible?.addEventListener("scroll", update);
    update();
    return () => {
      window.removeEventListener("resize", update);
      visible?.removeEventListener("resize", update);
      visible?.removeEventListener("scroll", update);
    };
  }, []);
  return viewport;
}
